import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";
import { auth, app } from "./firebaseConfig"; // Use named export

// Initialize Firebase services
const db = getFirestore(app); // Initialize Firestore with the app instance

// Login function
export const login = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    console.log("User logged in:", userCredential.user);
    return userCredential.user;
  } catch (error) {
    console.error("Login error:", error.message);
    throw error; // Throw to handle in UI
  }
};

// Signup function with dynamic role integration
export const signup = async (email, password, role) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);

    // Add user data to Firestore
    const userRef = doc(db, "users", userCredential.user.uid);
    await setDoc(userRef, {
      email,
      name: "",
      role, // Assign role dynamically
      avatarUrl: "",
      joinDate: new Date().toISOString(),
    });

    console.log("User signed up and added to Firestore:", userCredential.user);
    return userCredential.user;
  } catch (error) {
    console.error("Signup error:", error.message);
    throw error;
  }
};

// Logout function
export const logout = async () => {
  try {
    await signOut(auth);
    console.log("User logged out.");
  } catch (error) {
    console.error("Logout error:", error.message);
    throw error; // Throw to handle in UI
  }
};

export default auth;
